import { withInstall } from '@fx-front-framework/utils/with-install'
import VScrollingBarChart from './src/index.vue'

export const FxVScrollingBarChart = withInstall(VScrollingBarChart)
export default FxVScrollingBarChart

export * from './src/types'
